module.exports = __webpack_public_path__ + "img/gcyj.b0389205.png";